import Content, { WidthLimitation } from "./Content.component"

export { WidthLimitation }
export default Content